import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import UserType from "../constants/UserType";
import { GoogleMapResultData } from "../interfaces/GoogleMap";
import PersonalDetails from "../interfaces/PersonalDetails";
import User from "../interfaces/User";

export interface createAccountState {
  user: User;
}

const initialState: createAccountState = {
  user: {
    noOfTimeLogin: 0,
  },
};

export const createAccountSlice = createSlice({
  name: "createAccount",
  initialState,
  reducers: {
    setAddress: (state, action: PayloadAction<GoogleMapResultData>) => {
      state.user.address = action.payload;
      state.user.homeLocation = action.payload;
    },
    setPersonalDetails: (state, action: PayloadAction<PersonalDetails>) => {
      state.user.firstName = action.payload.firstName;
      state.user.lastName = action.payload.lastName;
      state.user.dob = action.payload.dob;
      state.user.phoneNumber = action.payload.phoneNumber;
      state.user.password = action.payload.password;
      state.user.email = action.payload.email;
    },
    setUserType: (state, action: PayloadAction<UserType>) => {
      state.user.userType = action.payload;
    },
    resetAccountState: () => initialState,
  },
});

export const {
  setAddress,
  setPersonalDetails,
  setUserType,
  resetAccountState,
} = createAccountSlice.actions;

export default createAccountSlice.reducer;
